var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shareApp"},[_c('keep-alive',{attrs:{"exclude":['Lobby', 'FreeCourse', 'PlanList' ]}},[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }